import { useTranslation } from 'react-i18next';
import { ENUM_LOCALE_CODE } from 'global.enums';
import { useObserver } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

export function useBrokerParams() {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;
  const defaultLanguage = ENUM_LOCALE_CODE.enUS;

  const {
    accountStore: { brokerParams },
  } = useMobxStore();

  return useObserver(() => ({
    currentLanguage: brokerParams?.[currentLanguage],
    defaultLanguage: brokerParams?.[defaultLanguage],
  }));
}
